/**
 * Подписанная `initData` Telegram — единственное удостоверение пользователя.
 *
 * Читается из SDK один раз при старте и живёт только в памяти: не в хранилище,
 * не в URL и не в логах. Обмена на токен нет — бэкенд проверяет подпись на
 * каждом запросе, так что и хранить, кроме неё, нечего.
 */
let rawInitData: string | null = null

export const setInitData = (value: string | null): void => {
  rawInitData = value?.trim() || null
}

export const getInitData = (): string | null => rawInitData
